import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { ClientReportCategories } from "../ClientReportCategories";
import { Layout } from '@singularsystems/neo-canvas-grid';
import TaxSummaryExtractReportCriteria from './TaxSummaryExtractReportCriteria';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import ServiceProviderApiClient from '../../../Maintenance/ApiClients/ServiceProviderApiClient';

@NeoReport("TaxSummaryExtract", { category: ClientReportCategories.HistoricDataReportExtracts })
export default class TaxSummaryExtractReport extends Report<TaxSummaryExtractReportCriteria> {
    public serviceProviderApiClient = new ServiceProviderApiClient();
    
    constructor() {
        super(TaxSummaryExtractReportCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.GridLayout lg={3}>
                <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.staticServiceProviderFileGroupingID}
                        bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                        .sort((x,y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                    />
                </Neo.FormGroup>
                <Neo.FormGroup 
                    appendText="fa-calendar"
                    bind={this.criteria.meta.date} />
            </Neo.GridLayout>
        </div>
    }
    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}